<div class="table-filters">
  @if (canSelectAll) {
    <div class="select-all">
      <label class="checkbox mt-2" fxLayout="row"
        fxLayoutAlign="start center">
        <input
          type="checkbox"
          [value]="'filterAll'"
          [checked]="allowSaveAll"
          (change)="allowSaveAllChecked()"
          class="field-checkbox mr-3" />
        <span class="checkbox-text">{{ 'FILTERS.SELECT-ALL' | translate }}</span>
      </label>
    </div>
  }
  @for (filterField of filterFields; track filterField.systemName) {
    <div>
      @if (filterField?.systemName) {
        <div>
          <div
            class="field-section"
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="expandCollapseField(filterField?.systemName)">
            <i class="icon {{ filterField.expanded ? 'icon-arrow_reveal_up' : 'icon-arrow_reveal_right' }}"></i>
            <div>{{ filterField?.name }}
              <span class="counter">{{ getFilterValuesCount(filterField?.systemName) }}</span>
            </div>
          </div>
          @if (filterField?.expanded === true) {
            <div
              class="field-values">
              @for (filterValue of filterField?.values; track filterValue.uId) {
                <div>
                  <label class="checkbox mt-2" fxLayout="row"
                    fxLayoutAlign="start center">
                    <input
                      type="checkbox"
                      [value]="'filterValue'"
                      [checked]="getFilterChecked(filterField.systemName, filterValue.uId)"
                      (change)="setFilterChecked(filterField.systemName, filterValue.uId)"
                      class="field-checkbox mr-3" />
                    <span class="field-text">{{ filterValue?.name }}</span>
                  </label>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<topo-confirm
  [isActive]="showSelectAllConfirmation"
  (respond)="onConfirmSelectAll($event)"
  title="{{ 'FILTERS.CONFIRM-SELECT-ALL-TITLE' | translate }}"
  message="{{ 'FILTERS.CONFIRM-SELECT-ALL-MESSAGE' | translate }}"
  yesText="{{ 'FILTERS.CONFIRM-YES' | translate }}"
  noText="{{ 'FILTERS.CONFIRM-NO' | translate }}"
icon="icon-close-X"></topo-confirm>
